import React, { createContext, useContext } from 'react';
import useSoundEffects from '../hooks/useSoundEffects';

const SoundContext = createContext(null);

export const SoundProvider = ({ children }) => {
  const soundEffects = useSoundEffects();

  return (
    <SoundContext.Provider value={soundEffects}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSound = () => {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSound must be used within a SoundProvider');
  }
  return context;
};
